export default __webpack_public_path__ + "static/media/br.46d9eb52.svg";